import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { RUNSCRIPT__REQUESTED } from "../constants/actionTypes";
import { browserHistory } from "react-router";
import { spaceToUnderscore } from "../helpers/helpers";

class RunScriptSection extends Component {
    constructor(props) {
        super(props);

        this.handleRunscript = this.handleRunscript.bind(this);
        this.handleLatestRunscripts = this.handleLatestRunscripts.bind(this);
        this.max_submissions_disabled = this.max_submissions_disabled.bind(this);
    }

    handleRunscript(e){
        e.preventDefault();

        const { assignment } = this.props,
            assignmentId = assignment.id
        ;

        this.props.dispatch({
            type: RUNSCRIPT__REQUESTED,
            payload: { assignmentId }
        });
    }

    handleLatestRunscripts(event) {
        event.preventDefault();

        const { assignment } = this.props,
            assignmentName = assignment.name,
            dropboxName = assignment.dropbox.name
        ;

        browserHistory.push(`/${dropboxName}/${spaceToUnderscore(assignmentName)}/runscripts`);
    }

    max_submissions_disabled() {
        const { assignment, submission } = this.props;

        return assignment !== undefined
            && assignment.submission_attempts_max !== 0
            && submission.attempts >= assignment.submission_attempts_max
        ;
    }

    render() {
        const { assignment, hasConfirmedSubmission, submission, uploadAllowed } = this.props,
            max_submissions_disabled = this.max_submissions_disabled()
        ;

        return submission && assignment
        ?
            (
                <div>
                    <div className="check-submitted">
                        <label className="help-text">
                            Checked submission {submission.attempts}
                            &nbsp;out of&nbsp;
                            {
                                assignment.submission_attempts_max > 0 ?
                                assignment.submission_attempts_max :
                                "unlimited"
                            } times
                        </label>
                        <br/>
                        <button
                            className="btn btn-md btn-primary mr-3"
                            onClick={this.handleRunscript}
                            disabled={
                                submission.id === '-1' ||
                                !uploadAllowed ||
                                max_submissions_disabled
                            }
                            title={
                                assignment.group_submission && submission.id === "-1"
                                ? "You must create a group before you can submit the assignment."
                                : "Check Submitted Files"
                            }
                        >
                            <i
                                className="fa fa-check-circle-o"
                            /> Check Submitted Files
                        </button>
                        <button
                            className="btn btn-link download-file pointer bottom right"
                            onClick={this.handleLatestRunscripts}
                            disabled={
                                submission.id === '-1' ||
                                !hasConfirmedSubmission ||
                                submission.attempts < 1
                            }
                            title={
                                assignment.group_submission && submission.id === "-1"
                                ? "You must create a group before you can submit the assignment."
                                : "Latest Check Submitted Files"
                            }
                        >
                            Latest Check Submitted Files
                        </button>
                    </div>
                    {
                        max_submissions_disabled
                        ? (
                            <div
                                style={{ marginBottom: '5px' }}
                                className="alert alert-warning"
                                role="alert"
                            >
                                <strong>
                                    Maximum Check Submitted Files has been reached
                                </strong>
                            </div>
                        ) : null
                    }
                </div>
            )
        :
            null
        ;
    }
}

RunScriptSection.propTypes = {
    auth: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    submission: PropTypes.object.isRequired,
    uploadAllowed: PropTypes.bool,
    hasConfirmedSubmission: PropTypes.bool,
};

function mapStateToProps(state) {
    const { assignment, auth, submission, dispatch } = state;

    return { assignment, auth, submission, dispatch };
}

export default connect(mapStateToProps)(RunScriptSection);






/** WEBPACK FOOTER **
 ** ./src/components/RunScriptSection.js
 **/